/* ==========================================================================

Renders:
This file handles logic that renders on the product-template.liquid.

Purpose: 
This file handles the logic of product-tool-features.liquid

Features:
    - Adds a quantity button for only LED Strip products
    - 

Helpers:
    - changeVisibility() 
    - checkCounter() 
    - setUpButtons()
    - setUpQtyButtons() 

Functions:
    - updatePage() → Renders design layout and interactions found on product pages

Note:
*Assumes user is not logged in.
- Renders at theme.liquid, Line 427

========================================================================== 

*/




const mainText = document.querySelector(".variant-header-description");
const messageVariant = document.querySelector(".variant-message");

const variants = document.querySelectorAll('.variant-btn');
const addToList = document.querySelector('.add-to-project-list-btn');

const lengthLabel = document.querySelector('.length-label');  
const lengthBtn = document.querySelector('.length-button'); 
const lengthDecrementBtn = document.querySelectorAll('.length-decrement-btn');
const lengthIncrementBtn = document.querySelectorAll('.length-increment-btn');
const lengthQty = document.querySelector('.l-counter');

const quantityLabel = document.querySelector('.product-quantity-label');
const quantityBtn = document.querySelector('.pq-button');
const qtyIncrementBtn = document.querySelectorAll('.pq-increment-btn'); 
const qtyDecrementBtn = document.querySelectorAll('.pq-decrement-btn');
const productQty = document.querySelector('.pq-counter');

const lengthEdit = document.getElementById("edit-length-value");
const qtyEdit = document.getElementById("edit-quantity-value");


// Shows or hides elements by setting their CSS display state
// Skips any elements not found on product page
function changeVisibility(elements, state) {
    for (let i =0; i < elements.length; i++) { 
        if (!elements[i]) {
            continue;
        }
        elements[i].style.display = state;  
    }
}

// Used by quantity and length buttons
// Decrements or increments a length or quantity counter
// Keeps selected value on the Add To Project in sync
function checkCounter(isIncrement, counter, attributeName) {
    let change = 0;
    if (isIncrement) {
        change += 1;
    } else {
        if (parseInt(counter.value) > 1) {
            change -= 1;
        }
    }
    addToList.dataset[attributeName] = parseInt(counter.value) + change;
    counter.value = parseInt(counter.value) + change;
}

// Initialises length and quantity's decrement and increment button event listeners 
// Done so the main product logic can enable length and shared quantity controls with a single function call
function setUpButtons() {
    lengthDecrementBtn.forEach(element => {
        element.addEventListener("click", function(e) {
            checkCounter(false, lengthQty, 'selectedLength');
        })
    });

    lengthIncrementBtn.forEach(element => {
        element.addEventListener("click", function(e) {
            checkCounter(true, lengthQty, 'selectedLength');
        })
    })

    setUpQtyButtons();
}

function setUpQtyButtons() {
    qtyDecrementBtn.forEach(element => {
        element.addEventListener("click", function(e) {
            checkCounter(false, productQty, 'selectedQuantity');
        })
    });

    qtyIncrementBtn.forEach(element => {
        element.addEventListener("click", function(e) {
            checkCounter(true, productQty, 'selectedQuantity');
        })
    })
}

/* Shared by length and quantity inputs 
    Validates entered value and keeps the value displayed to the user consistent with the 
    value stored on the Add To Project button
    Values below 1 are reset to 1
*/
function checkInput(input, attributeName) {
    if (input.value <= 1) {
        addToList.dataset[attributeName] = 1;
        input.value = 1;
    } else {
        addToList.dataset[attributeName] = parseInt(input.value) ;
        input.value = parseInt(input.value);
    }
}

// Prevents the length input listener from being attached more than once
let lengthBound = false;
function editLengthInput() {
    if (lengthBound) return;
    lengthEdit.addEventListener("input", function(e) {
        checkInput(e.target, 'selectedLength');
    })
    lengthBound = true;
}

// Prevents the quantity input listener from being attached more than once
let quantityBound = false;
function editQtyInput() {
    if (quantityBound) return;
    qtyEdit.addEventListener("input", function(e) {
        checkInput(e.target, 'selectedQuantity');
    })
    quantityBound = true;
}


// Shows or hides product-page elements based on the selected product type
// Handles the initial setup of length, quantity, and variant controls.
function updatePage() {

    if (!addToList) return; 
    if (!lengthBtn) {
        console.warn('project-tool-features.js: .length-button not found');
        return;
    }

    // Reset controls and establish default values before determining product type
    addToList.dataset.selectedQuantity = '1';
    addToList.dataset.selectedLength = '1';
    changeVisibility([lengthLabel, lengthBtn, addToList], 'none');
    changeVisibility([quantityLabel, quantityBtn], 'none');
    changeVisibility([mainText, messageVariant], 'none');

    // Fetched from project-tool-features.liquid
    const isLedStrip = lengthBtn.dataset.isLedStrip === 'true';
    const isProfile = lengthBtn.dataset.isProfile === 'true';
    const isCable = lengthBtn.dataset.isCable === 'true';
    const isController = lengthBtn.dataset.isController === 'true';
    const isDriver = lengthBtn.dataset.isDriver === 'true';
    const isTotalLength = lengthBtn.dataset.isTotalLength === 'true';


    /* LED STRIPS 
        LED strips with more than one variant, require the user to select
       a variant before product controls become available
    */
    if (isLedStrip && variants.length ) { 

    changeVisibility([mainText, messageVariant], 'block');
    variants.forEach(element => {
        element.addEventListener("click", function(e) {
            addToList.dataset.selectedVariant = e.target.dataset.variantTitle;
            addToList.dataset.selectedVariantSku = e.target.dataset.variantSku; 
            addToList.dataset.selectedVariantId = e.target.dataset.variantId; 
            addToList.dataset.selectedQuantity = e.target.dataset.variantQuantity; 
            addToList.dataset.selectedLength = e.target.dataset.variantLength; 
            addToList.dataset.selectedVariantImage = e.target.dataset.variantImage;

            const variantSKU = e.target.dataset.variantSku.toLowerCase();
            const productTitle = addToList.dataset.title.toLowerCase();

            if (variantSKU.endsWith('m') || isController || isDriver) {
                addToList.dataset.hasLength = 'false';
                changeVisibility([lengthLabel, lengthBtn], 'none');
            } else {
                addToList.dataset.hasLength = 'true';
                changeVisibility([lengthLabel], 'block');
                changeVisibility([lengthBtn], 'flex');
            }
            changeVisibility([quantityLabel], 'block');
            changeVisibility([quantityBtn], 'flex');
            changeVisibility([addToList], 'block');
            
            for (let i=0; i < variants.length; i++) {
                variants[i].classList.remove('active');
            }
            e.target.classList.add('active');
        })
        lengthQty.value = 1;
        productQty.value = 1;
        editLengthInput();
        editQtyInput();
    });
    setUpButtons();

    // LED strips with no variants displays all product controls: length and quantity
    } else if (isLedStrip){ 

        changeVisibility([mainText, messageVariant], 'none');
        const productTitle = addToList.dataset.title.toLowerCase();
        const productSKU = addToList.dataset.sku.toLowerCase();

        if (productSKU.endsWith('m')  || isController || isDriver) {
            addToList.dataset.hasLength = 'false';
            changeVisibility([lengthLabel, lengthBtn], 'none');
        } else {
            addToList.dataset.hasLength = 'true';
            changeVisibility([lengthLabel], 'block');
            changeVisibility([lengthBtn], 'flex');
        }
        changeVisibility([quantityLabel], 'block');
        changeVisibility([quantityBtn], 'flex');
        changeVisibility([addToList], 'block');
        
        if (productTitle.includes('roll')) {
            addToList.dataset.hasLength = 'false';
            changeVisibility([mainText], 'none');
            changeVisibility([lengthLabel, lengthBtn], 'none');
            changeVisibility([quantityLabel], 'block');
            changeVisibility([quantityBtn], 'flex');
            changeVisibility([addToList], 'block');
        }
        lengthQty.value = 1;
        productQty.value = 1;
        editLengthInput();
        editQtyInput();
        setUpButtons();
    
    /* ALUMINIUM PROFILES */
    /* Aluminium profiles with more than one variant, require the user to select
       a variant before product controls become available */ 
    } else if (isProfile && variants.length) { 

        changeVisibility([mainText, messageVariant], 'block');
        variants.forEach(element => {
            element.addEventListener("click", function(e) {
                addToList.dataset.selectedVariant = e.target.dataset.variantTitle;
                addToList.dataset.selectedVariantSku = e.target.dataset.variantSku; 
                addToList.dataset.selectedVariantId = e.target.dataset.variantId; 
                addToList.dataset.selectedQuantity = e.target.dataset.variantQuantity; 
                addToList.dataset.selectedLength = e.target.dataset.variantLength; 
                addToList.dataset.productName = e.target.dataset.productTitle; 
                addToList.dataset.productSku = e.target.dataset.productSku; 
                addToList.dataset.selectedVariantImage = e.target.dataset.variantImage;

                const sku = e.target.dataset.productSku;
                const variantType = e.target.dataset.variantSku.toLowerCase();
                const listedProfileVariants = variantType?.endsWith('m') || variantType?.endsWith('mc') || variantType?.endsWith('ec') || variantType?.endsWith('cr');
                
                // Aluminium profiles with SD (standard diffusers) or are not MC, EC can be sold by length
                if (variantType?.endsWith('sd') || variantType && !listedProfileVariants) {
                    addToList.dataset.hasLength = 'true';
                    changeVisibility([lengthLabel], 'block');
                    changeVisibility([lengthBtn], 'flex');
                    lengthQty.value = 1;
                    editLengthInput();
                } else {
                    addToList.dataset.hasLength = 'false';
                    changeVisibility([lengthLabel, lengthBtn], 'none');
                }
                changeVisibility([quantityLabel], 'block');
                changeVisibility([quantityBtn], 'flex');
                changeVisibility([addToList], 'block');
                productQty.value = 1;
                editQtyInput();

                for (let i=0; i < variants.length; i++) {
                    variants[i].classList.remove('active');
                }
                e.target.classList.add('active');
            })
            
        });
        setUpButtons();
  
    // Aluminium profiles with no variants displays all product controls: length and quantity
    }  else if (isProfile) { 
        changeVisibility([mainText, messageVariant], 'none');
        addToList.dataset.selectedVariantSku = addToList.dataset.sku; 
        addToList.dataset.productName = addToList.dataset.title; 
        addToList.dataset.productSku = addToList.dataset.sku;

        const title = addToList.dataset.title;
        if (title.toLowerCase().includes('to suit') && !(title.toLowerCase().includes('long run') || title.toLowerCase().includes('channel') || title.toLowerCase().includes('diffuser'))) {
            addToList.dataset.hasLength = 'false';
             changeVisibility([lengthLabel, lengthBtn], 'none');
        } else {
            addToList.dataset.hasLength = 'true';
            changeVisibility([lengthLabel], 'block');
            changeVisibility([lengthBtn], 'flex');
        }

        changeVisibility([quantityLabel], 'block');
        changeVisibility([quantityBtn], 'flex');
        changeVisibility([addToList], 'block');

        lengthQty.value = 1;
        productQty.value = 1;
        editLengthInput();
        editQtyInput();

    /* CABLES */
    // Cables with variants displays all product controls: length and quantity
    }   else if (isCable && variants.length) { 
        changeVisibility([mainText, messageVariant], 'block');

        variants.forEach(element => {
            element.addEventListener("click", function(e){
                addToList.dataset.selectedVariant = e.target.dataset.variantTitle;
                addToList.dataset.selectedVariantSku = e.target.dataset.variantSku; 
                addToList.dataset.selectedVariantId = e.target.dataset.variantId; 
                addToList.dataset.selectedQuantity = e.target.dataset.variantQuantity; 
                addToList.dataset.selectedLength = e.target.dataset.variantLength; 
                addToList.dataset.selectedVariantImage = e.target.dataset.variantImage;
                addToList.dataset.hasLength = 'true';

                changeVisibility([lengthLabel], 'block');
                changeVisibility([lengthBtn], 'flex');
                changeVisibility([quantityLabel], 'block');
                changeVisibility([quantityBtn], 'flex');
                changeVisibility([addToList], 'block');

                for (let i=0; i < variants.length; i++) {
                    variants[i].classList.remove('active');
                }
                e.target.classList.add('active');

            })
        });
        setUpButtons();
        lengthQty.value = 1;
        productQty.value = 1;
        editLengthInput();
        editQtyInput();

    // Cables with no variants displays all product controls: length and quantity
    }   else if (isCable) { // Condition: Products that are cables and have no variants

        addToList.dataset.selectedVariantSku = addToList.dataset.sku; 
        addToList.dataset.productName = addToList.dataset.title; 
        addToList.dataset.productSku = addToList.dataset.sku;

        const title = addToList.dataset.title;

        changeVisibility([mainText, messageVariant], 'none');
        if (title.endsWith('m Roll') || /-\s*\d+mm/.test(title) || isTotalLength) {
            addToList.dataset.hasLength = 'false';
            changeVisibility([lengthLabel, lengthBtn], 'none');
            setUpQtyButtons();
        } else {
            addToList.dataset.hasLength = 'true';
            changeVisibility([lengthLabel], 'block');
            changeVisibility([lengthBtn], 'flex');
            setUpButtons();
            lengthQty.value = 1;
            editLengthInput();
        }
        changeVisibility([quantityLabel], 'block');
        changeVisibility([quantityBtn], 'flex');
        changeVisibility([addToList], 'block');
        productQty.value = 1;
        editQtyInput();

        /* Notes:
        - isTotalLength looks at product's description
        */

    /* OTHER PRODUCT TYPES */
        // Products with more than one variant, require the user to select a variant before product controls become available. 
        // Excludes LED strips, profiles
    }   else if (variants.length) {  

        changeVisibility([mainText, messageVariant], 'block');
        changeVisibility([addToList], 'none');

        variants.forEach(element => {
            element.addEventListener("click", function(e) {
                addToList.dataset.selectedVariant = e.target.dataset.variantTitle;
                addToList.dataset.selectedVariantSku = e.target.dataset.variantSku; 
                addToList.dataset.selectedVariantId = e.target.dataset.variantId; 
                addToList.dataset.selectedQuantity = e.target.dataset.variantQuantity; 
                addToList.dataset.selectedVariantImage = e.target.dataset.variantImage;
                addToList.dataset.hasLength = 'false';

                changeVisibility([lengthLabel, lengthBtn], 'none');
                changeVisibility([quantityLabel], 'block');
                changeVisibility([quantityBtn], 'flex');
                changeVisibility([addToList], 'block');
                
                for (let i=0; i < variants.length; i++) {
                    variants[i].classList.remove('active');
                }
                e.target.classList.add('active');

            })
        });
        setUpQtyButtons();
        productQty.value = 1;
        editQtyInput();

    // Products outside defined product types and without variants only displays quantity controls
    } else {
        addToList.dataset.hasLength = 'false';

        changeVisibility([mainText, messageVariant], 'none');
        changeVisibility([lengthLabel, lengthBtn], 'none');
        changeVisibility([quantityLabel], 'block');
        changeVisibility([quantityBtn], 'flex');
        changeVisibility([addToList], 'block');
        
        setUpQtyButtons();
        productQty.value = 1;
        editQtyInput();
    }
}

document.addEventListener("DOMContentLoaded", (event) => {
    updatePage();
});


{{ 'project-tool.js' | asset_url | script_tag }}
{{ 'theme.js' | asset_url | script_tag }}


